import { render, staticRenderFns } from "./BasicCompose.vue?vue&type=template&id=524bfd58&scoped=true"
import script from "./BasicCompose.vue?vue&type=script&lang=js"
export * from "./BasicCompose.vue?vue&type=script&lang=js"
import style0 from "./BasicCompose.vue?vue&type=style&index=0&id=524bfd58&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524bfd58",
  null
  
)

export default component.exports